import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'Components/UI/Modal';
import Button from 'Components/UI/Button';
import Form from 'Components/UI/Form/Form';
import Field from 'Components/UI/Field';
import schema from './novaPasta.schema';
import { ButtonsWrapper, Container } from './styles';
import { IFileData } from 'Data/interfaces/ListagemArquivos/IListFilesResponse';

interface INovaPasta {
  visible?: boolean;
  file: IFileData | null;
  newFolderDestination?: string | null;
  isLoading?: boolean;
  onCancel?: () => void;
  onCreate?: (folderName: string, folderDestination?: string) => void;
  onEdit?: (folderName: string, file: IFileData) => void;
}

const NovaPasta: FC<INovaPasta> = ({
  visible,
  file,
  newFolderDestination,
  isLoading,
  onCancel,
  onCreate,
  onEdit,
}) => {
  const { t } = useTranslation(['listagemArquivos', 'common']);
  const [isSubmited, setIsSubmited] = useState(false);

  const createFolder = (values: any, errors: any) => {
    if (onCreate && values) {
      onCreate(values.folderName, newFolderDestination || undefined);
    }
    setIsSubmited(false);
  };

  const editFolder = (values: any, errors: any) => {
    if (onEdit && values && file) {
      onEdit(values.folderName, file);
    }
    setIsSubmited(false);
  };

  const buttons = (
    <ButtonsWrapper>
      <Button
        onClick={onCancel}
        type="text"
        className="buttonCancel"
      >
        {t('common:cancel')}
      </Button>
      <Button
        type="primary"
        htmlType="submit"
        onClick={() => setIsSubmited(true)}
        className="buttonSubmit"
        disabled={isLoading}
        loading={isLoading}
      >
        {!!file ? t('common:save') : t('listagemArquivos:folders.newFolderTitle')}
      </Button>
    </ButtonsWrapper>
  );

  return (
    <Modal
      visible={visible}
      title={!!file ? t('listagemArquivos:folders.renameFolderTitle') : t('listagemArquivos:folders.newFolderTitle')}
      footerButtons={buttons}
      footerActive={false}
      width={400}
      customClassName
      newHeader
      onCancel={onCancel}
    >
      <Container>
        <Form
          schema={schema}
          isSubmited={isSubmited}
          resetForm={true}
          onSubmit={!!file ? editFolder : createFolder}
        >
          <Field
            name='folderName'
            label={t('listagemArquivos:folders.folderNameLabel')}
            defaultValue={file?.Name}
            disabled={isLoading}
          />
        </Form>
      </Container>
    </Modal>
  );
};

export default NovaPasta;
